 
import "../../pages/Surveys/style.css";
import cogoToast from "cogo-toast";
import "survey-core/defaultV2.min.css";
import "survey-creator-core/survey-creator-core.min.css";
import { Spinner } from "reactstrap";
import { useHistory } from "react-router-dom";
 
import { useState, useEffect, useRef, useMemo, useCallback } from "react";
 
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
 
import { SUCCESS_RESULT, ENDPOINTS,LOCAL_PATHS } from "../../Constants";
import { getTemplateByName, genericPost, genericGet } from "../../services/Api";
 
import { PERMS } from '../../pages/config/perms'
import ability from '../../pages/config/defineAbility';
import moment from 'moment';
import {
  
  Modal,
  ModalHeader,
  ModalBody,
 
 
} from 'reactstrap';

import React from 'react'
import { FaSearch, FaTimesCircle ,FaArrowRight} from "react-icons/fa";


const EmployeeProfile = (props) => {
  const history = useHistory();
  const [is_loading, setIsLoading] = useState(false);
const [show_bank_account_creation, setshow_bank_account_creation] = useState(false)
const [staff_data, setstaff_data] = useState(null)
const { _staff_id } = (props.location && props.location.state) || {};
const [active_tab, setactive_tab] = useState(1)
const [staff_code, setstaff_code] = useState('')

const [month, setmonth] = useState(0)
const [year, setyear] = useState(0)
const [deduction_plans, setdeduction_plans] = useState([])
const [deduction_amount, setdecution_amount] = useState(0)
const [amount_requested, setamount_requested] = useState(0);
const [request_date, setrequest_date] = useState(null)
const [advance_payment_method, setadvance_payment_method] = useState('')
const [advance_reason, setadvance_reason] = useState('')
const [advance_bank_id, setadvance_bank_id] = useState('')

const [bank_name, setbank_name] = useState("")
const [bank_country, setbank_country] = useState("")
const [bank_branch, setbank_branch] = useState("")
const [bank_account, setbank_account] = useState("")
const [bank_account_name, setbank_account_name] = useState("")



  const toggle = () => setshow_bank_account_creation(!show_bank_account_creation);

  useEffect(() => {
    fetch_data();
    setyear(getCurrentYear())
    return () => {};
  }, []);

  const get_month_name=(month)=>{

    const date = new Date(year, month, 1);   
    const month_name = date.toLocaleString('default', { month: 'long' });
    return month_name;
   }


   const createBankAccount =  (e) => {
    setIsLoading(true)
    e?.preventDefault();
   let data= {
    "staff_id":  staff_data?.staff_code,
    "bank": bank_name,
    "country": bank_country,
    "bank_branch": bank_branch,
    "account_name" : bank_account_name ,
    "account_number":  bank_account
  }
  
  console.clear();
  console.log(data);
  
  genericPost(ENDPOINTS.CREATE_STAFF_BANK_ACCOUNT, data)
  .then((response) => {
      setIsLoading(false);
      if (response.status == 200) {
          if (response.data.status == SUCCESS_RESULT) {
              cogoToast.success(response.data.message, {
                  hideAfter: 5,
              });
              setshow_bank_account_creation(false);
              fetch_data();
          } else {
              cogoToast.error(response.data.message, {
                  hideAfter: 5,
              });
          }
      }
  })
  .catch((err) => {
      setIsLoading(false);
      console.log(err);
      cogoToast.error("Something went wrong, please Try again. " + err, {
          hideAfter: 5,
      });
  });
   
   
  }

const submit_advance_request=()=>{
  setIsLoading(true);
if(advance_payment_method==""){
  cogoToast.error("Please select Payment method.", {});

  return;
}
  let data={
    "staff_id": staff_data?.staff_id,
    "date_requested": request_date,
    "amount_requested": amount_requested,
    "account_id": advance_bank_id,
    "payment_method": advance_payment_method,
    "staff_signature": "N/A",
    "reason": advance_reason,
     "deduction_plan": deduction_plans
    }
 
    console.log(data)

genericPost(ENDPOINTS.SAVE_SALARY_ADVANCE, data)
.then((res) => {
  if (res.status == 200) {
    if (res.data.status == SUCCESS_RESULT) {
       
      cogoToast.success(res.data.message, {});
      setdeduction_plans([]);
      setadvance_reason("");
      setamount_requested("");

   
    } else {
      cogoToast.error(res.data.message, {});
    }
  } else {
    cogoToast.error("Connection error. Please try again.", {});
  }
  setIsLoading(false);
})
.catch((err) => {
  // log("Error:: ");
  // log(err);
  setIsLoading(false);
  cogoToast.error("Critical error occurred. Please try again.", {});
});

 


}

const get_deduction_plan_total=() => {
let total=0;
let _plans=deduction_plans;
_plans=_plans.forEach((obj)=> {
  total=Number(total)+Number(obj.amount);
})
return total;
}
const add_deduction_plan=() => {
  if(!month>0){
    cogoToast.error("Please select month. " , {
      hideAfter: 5,
  });
return;
  }
  if(!deduction_amount>0){
    cogoToast.error("Amount should be greater than Zero. " , {
      hideAfter: 5,
  });
return;
  }
  if(Number(get_deduction_plan_total())+Number(deduction_amount) > amount_requested ) {
    cogoToast.error("Deduction total  should not be greater than requested amount of  "+amount_requested , {
      hideAfter: 5,
  });

  return;
  }
if(year!="" && month!="" && deduction_amount > 0){

 // check if the start month is valid
  
 const start_date = new Date(staff_data?.start_month_salary_advance+"-01");
 const selected_date = new Date(year+'-'+month+'-01');
 start_date.setHours(0, 0, 0, 0);
 start_date.setHours(0, 0, 0, 0);
 
if( moment(start_date).isAfter(selected_date)     )
{
  cogoToast.error("Deduction plan should start from   " +  staff_data?.start_month_salary_advance   , {
    hideAfter: 5,
});
return;
}


  if(!amount_requested>0){
    cogoToast.error("Amount Requested should be greater than Zero. " , {
      hideAfter: 5,
  });
  return;
  }
  let plans=deduction_plans;
  plans.push({year:year,month:month,amount:deduction_amount});
  setdecution_amount(0)
  setmonth(0)
setTimeout(() => {
  document.getElementById("add_deduction_plan")?.reset();
  setdeduction_plans([]);
  setdeduction_plans(plans);
}, 100);


}}

 



 
 
  const delete_plan=(plan)=>{
    let _plans=deduction_plans;
    _plans=_plans.filter(function( obj ) {
      return obj.month !== plan.month &&  obj.amount !== plan.amount;
  })
    setdeduction_plans([]);
    setdeduction_plans(_plans);
  
  }

  const find_staff_by_code = () => {
    setIsLoading(true);



 
    genericPost(ENDPOINTS.LIST_STAFF_DETAILS, { "staff_code":staff_code})
      .then((res) => {
        if (res.status == 200) {
          if (res.data.status == SUCCESS_RESULT) {
            setstaff_data(res.data["data"]);
         
          } else {
            cogoToast.error(res.data.message, {});
          }
        } else {
          cogoToast.error("Connection error. Please try again.", {});
        }
        setIsLoading(false);
      })
      .catch((err) => {
        // log("Error:: ");
        // log(err);
        setIsLoading(false);
        cogoToast.error("Critical error occurred. Please try again.", {});
      });
  };
  const getCurrentYear=()=>{
    return new Date().getFullYear();
  }
  
  const fetch_data = () => {
    setIsLoading(true);



 
    genericPost(ENDPOINTS.LIST_STAFF_DETAILS, { "staff_id":_staff_id})
      .then((res) => {
        if (res.status == 200) {
          if (res.data.status == SUCCESS_RESULT) {
            setstaff_data(res.data["data"]);
         
          } else {
            cogoToast.error(res.data.message, {});
          }
        } else {
          cogoToast.error("Connection error. Please try again.", {});
        }
        setIsLoading(false);
      })
      .catch((err) => {
        // log("Error:: ");
        // log(err);
        setIsLoading(false);
        cogoToast.error("Critical error occurred. Please try again.", {});
      });
  };
  return (


    <>
    {/* <div className="card">
                  <div className="card-header">
                    <ul className="nav nav-tabs card-header-tabs nav-fill" data-bs-toggle="tabs" role="tablist">
                      <li className="nav-item" role="presentation">
                        <a href="#tabs-home-7" className="nav-link active" data-bs-toggle="tab" aria-selected="true" role="tab"> 
                          <svg xmlns="http://www.w3.org/2000/svg" className="icon me-2" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M5 12l-2 0l9 -9l9 9l-2 0"></path><path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7"></path><path d="M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6"></path></svg>
                          Personal Info</a>
                      </li>
                      <li className="nav-item" role="presentation">
                        <a href="#tabs-profile-7" className="nav-link" data-bs-toggle="tab" aria-selected="false" role="tab" tabindex="-1"> 
                          <svg xmlns="http://www.w3.org/2000/svg" className="icon me-2" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"></path><path d="M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"></path></svg>
                          Contract</a>
                      </li>
                      <li className="nav-item" role="presentation">
                        <a href="#tabs-activity-7" className="nav-link" data-bs-toggle="tab" aria-selected="false" role="tab" tabindex="-1"> 
                          <svg xmlns="http://www.w3.org/2000/svg" className="icon me-2" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M3 12h4l3 8l4 -16l3 8h4"></path></svg>
                          Budget Allocations</a>
                      </li>
                    </ul>
                  </div>
                  <div className="card-body">
                    <div className="tab-content">
                      <div className="tab-pane active show" id="tabs-home-7" role="tabpanel">
                        <h4>Personal Information</h4>
                     
                     <table className='tbl'>
                    <tr>  <td>staff ID</td> <td>xxxx</td> </tr>
                    <tr>  <td>staff Name</td> <td>xxxx</td> </tr>
                    <tr>  <td>Gender Name</td> <td>xxxx</td> </tr>
                    <tr>  <td>Email</td> <td>xxxx</td> </tr>
                    <tr>  <td>Telephone</td> <td>xxxx</td> </tr>


                      </table>
                     
                       
                     
                      </div>
                      <div className="tab-pane" id="tabs-profile-7" role="tabpanel">
                        <h4>Profile tab</h4>
                        <div>Fringilla egestas nunc quis tellus diam rhoncus ultricies tristique enim at diam, sem nunc amet, pellentesque id egestas velit sed</div>
                      </div>
                      <div className="tab-pane" id="tabs-activity-7" role="tabpanel">
                        <h4>Activity tab</h4>
                        <div>Donec ac vitae diam amet vel leo egestas consequat rhoncus in luctus amet, facilisi sit mauris accumsan nibh habitant senectus</div>
                      </div>
                    </div>
                  </div>
                </div> */}


<div className="page-wrapper">
 
 {/* {JSON.stringify(staff_data)} */}
    
 
        <div className="page-body">
          <div className="container-xl">
            <div className="card">
              <div className="row g-0">
                <div className="col-12 col-md-3 border-end">
                  <div className="card-body">

                     {/* <div className="input-group">
                                <input type="text" onChange={(e)=>setstaff_code(e.target.value)} className="form-control" placeholder='SOM XXXX'/>
                                <button className="btn btn-primary" type="button" onClick={()=>find_staff_by_code()}><FaSearch style={{color:"white"}}></FaSearch> </button>
                              </div> */}
                   
                    <h4 className="subheader">Navigation</h4> <br/>
                    <div className="list-group list-group-transparent">
                      <a onClick={()=>setactive_tab(1)}   className={active_tab==1?"list-group-item list-group-item-action d-flex align-items-center active":"list-group-item list-group-item-action d-flex align-items-center"}>Profile Details</a>
                      <a  onClick={()=>setactive_tab(2)}   className={active_tab==2?"list-group-item list-group-item-action d-flex align-items-center active":"list-group-item list-group-item-action d-flex align-items-center"}>Contract & Allowances</a>
                      <a   onClick={()=>setactive_tab(3)}   className={active_tab==3?"list-group-item list-group-item-action d-flex align-items-center active":"list-group-item list-group-item-action d-flex align-items-center"}>Budget Allocations</a>
                      <a   onClick={()=>setactive_tab(4)}   className={active_tab==4?"list-group-item list-group-item-action d-flex align-items-center active":"list-group-item list-group-item-action d-flex align-items-center"}>Advance Request</a>
                      <a   onClick={()=>setactive_tab(5)}   className={active_tab==5?"list-group-item list-group-item-action d-flex align-items-center active":"list-group-item list-group-item-action d-flex align-items-center"}>Payslips</a>
                     
                    </div>
                   
                  </div>
                </div>
                <div className="col-12 col-md-9 d-flex flex-column">
                  
                  
                  
                  {active_tab==1 && 
                  <div className="card-body">
                    <h1  >Profile Details</h1>
                     <hr/>
                    <div className="row align-items-center">
                      <div className="col-auto"><span className="avatar avatar-xl"  >
                      {staff_data?.photo ? <img src={`data:image/png;base64,${staff_data?.photo}`}/>: ''}
                      </span>
                      </div>
                      <div className="col-auto"><span href="#" className=" ">
                      <h3 className="card-title mt-4">{staff_data?.staff_name}</h3>
                   <center>  {staff_data?.role_name} </center><br/>
                  
                        </span></div>
                      
                    </div>
                  
                   <hr/>
                    <table className="info_table">


<tr>
  <td className="blue-bg">STAFF ID</td> <td>{staff_data?.staff_code} </td>
  <td className="blue-bg">Email Address</td> <td> {staff_data?.email}</td>
  
  </tr>
  <tr>
  <td className="blue-bg">Phone</td> <td> {staff_data?.telephone}</td>
  <td className="blue-bg"> Gender </td>  <td>{staff_data?.gender} </td>
  
  </tr>
  <tr>
  <td className="blue-bg">Passport </td> <td> {staff_data?.passport}</td>
  <td className="blue-bg">Blood Group</td> <td> {staff_data?.blood_group}</td>
  </tr>

 
 
</table>
 
                    <br/>
                    <h2>Bank Accounts</h2>

                    {ability.can(PERMS.CREATE, PERMS.CREATE_BANK_ACCOUNT) && (
<button className="btn-sm btn primary" style={{float:"right"}} onClick={()=>setshow_bank_account_creation(true)}>Create New Account</button>
)}
<table className="info_table">
  <thead>
    <tr>
      <th>Bank Name</th>
      <th>Country </th>
                                <th>Branch </th>
                                <th>Account Name</th>
                                <th>Bank Account</th>
                                
                                <th>Created by</th>
                                






    </tr>
  </thead>



                    {staff_data?.bank_accounts?.map((i)=>{
                    return  <tr>
                        <td>  {i.bank} </td>
                        <td>  {i.country} </td>
                        <td>  {i.bank_branch} </td>
                        <td>  {i.account_name} </td>
                        <td>  {i.bank_account} </td>
                        <td>  {i.created_by} </td>
                      
                         
</tr>
                    })}
                    </table>

                  </div>
}
                 
{active_tab==2 && 
                  <div className="card-body mg-200" >
                    <h1>Contract & Staff Allowance Details</h1>
                    <hr/>
                     <h2>Contract Details</h2>
                    <table className="table info_table">
                      <tr>
<td>Contract Start Date : </td> <td className="bold">{staff_data?.contract?.start_date}</td>
                      </tr>
                      <tr>
<td>Contract End Date : </td> <td className="bold">{staff_data?.contract?.end_date}</td>
                      </tr>
                      <tr>
<td>Contract Start Status : </td> <td className="bold">{staff_data?.contract?.status=="10001"?"Active":"In-Active"}</td>
                      </tr>
                      <tr>
<td>Contracted Salary  : </td> <td className="bold">${staff_data?.contract?.contracted_salary}</td>
                      </tr>
                    </table>
                    <hr/>
                    <h2>Staff Allowances</h2>
                    
                   
<table className="info_table">
  <thead>
    <tr>
      <th>Allowance</th>
      <th>Amount</th>

    </tr>
  </thead>

                    {staff_data?.staff_allowances?.map((i)=>{
                    return  <tr>
                        <td>
                      
                          {i.name}
                        </td>
                        <td>
                         ${i.amount}
                        </td>
                      </tr>
                    })}
                    </table>

                    
                    <br/>
                    <h2>Staff Taxes</h2>
                    <table className="info_table">
  <thead>
    <tr>
      <th>Tax Name</th>
      <th>Assigned by</th>

    </tr>
  </thead>

                    {staff_data?.Assigned_taxes?.map((i)=>{
                    return  <tr>
                        <td>
                      
                          {i.tax_name}
                        </td>
                        <td>
                          {i.assigned_by}
                        </td>
                      </tr>
                    })}
                    </table>
                  </div>
}

{active_tab==3 && 
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-7"><h1>Budget Details</h1></div>
                      <div className="col-md-5">
                     <h2 style={{color:"#0088d1"}}> Taxable Amount : ${staff_data.taxable_amount} </h2>
                        </div>
                      </div>
                    
                     
               
                    <hr/>
                    <h2>Yearly Budget Allocations</h2>

                    <table className="info_table">
                      <thead>
                        <tr>
                          <th>Project Name</th>
                          <th>Budget Code</th>
                                                    <th>Budget Name</th>
                                                    <th>Percentage</th>
                                                    <th>Amount</th>
                                                    <th>Balance</th>
                                                    <th>Created by</th>
                                                    {/* <th>Created at</th> */}
                                                    <th>Updated at</th>





                    
                        </tr>
                      </thead>
                    
                    

                                        {staff_data?.budget_allocation?.map((i)=>{
                                        return  <tr>
                                            <td>  {i.project_name} </td>
                                            <td>  {i.budget_code} </td>
                                            <td>  {i.budget_name} </td>
                                            <td>  {i.percentage}% </td>
                                            <td>  ${i.amount} </td>
                                            <td>  ${i.balance} </td>
                                            <td>  {i.created_by} </td>
                                            {/* <td>  {i.created_at} </td> */}
                                            <td>  {i.updated_at} </td>
   </tr>
                                        })}
                                        </table>

<br/>

                                        <h2>Monthly Budget Allocations</h2>
                    
                   
                    <table className="info_table">
                      <thead>
                        <tr>
                          <th>Project Name</th>
                          <th>Budget Code</th>
                                                    <th>Budget Name</th>
                                                    <th>Percentage</th>
                                                    <th>Amount</th>
                                               
                                                    <th>Created by</th>
                                                    <th>Created at</th>
                                                    <th>Updated at</th>





                    
                        </tr>
                      </thead>
                    
                    

                                        {staff_data?.budget_monthly_allocation?.map((i)=>{
                                        return  <tr>
                                            <td>  {i.project_name} </td>
                                            <td>  {i.budget_code} </td>
                                            <td>  {i.budget_name} </td>
                                            <td>  {i.percentage}% </td>
                                            <td>  ${i.amount} </td>
                                           
                                            <td>  {i.created_by} </td>
                                            <td>  {i.created_at} </td>
                                            <td>  {i.updated_at} </td>
   </tr>
                                        })}
                                        </table>
<br/>
                                        <h2>Schemes</h2>
                    
                   
                    <table className="info_table">
                      <thead>
                        <tr>
                          <th>Name </th>
                                             
                                                    <th>Percentage</th>
                                                    <th>Total Amount</th>
                                               
                                                    





                    
                        </tr>
                      </thead>
                    
                    

                                        {staff_data?.schemes?.map((i)=>{
                                        return  <tr>
                                            <td>  {i.name} </td>
                                            <td>  {i.amount}%  </td>
                                            <td>  ${i.total_amount} </td>
                                            
   </tr>
                                        })}
                                        </table>
                    
                  </div>
}


{active_tab==4 && 
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-7"><h1>Advance Request</h1></div>
                      <div className="col-md-5">
                     <h2 style={{color:"#0088d1"}}> Contracted Salary: ${staff_data?.contract?.contracted_salary} </h2>
                        </div>
                      </div>
                    
                     
               
                    <hr/>
                   

               

<div className="row">
  <div className="col-md-3">
    Request Date
    <input type="date" onChange={(e)=>setrequest_date(e.target.value)} set name="request_date" className="form-control" />
    Amount Requested
    <input type="number" onChange={(e)=>setamount_requested(e.target.value)} name="amount_requested" className="form-control" />
    Payment Method
    <select name="advance_payment_method"
            className="form-control"
            onChange={(e) => {setadvance_payment_method(e.target.value)}
               
             
            }
            required={true}
          >
            <option value='CHEQUE'>CHEQUE</option>
            <option value='CASH'>CASH</option>


            </select>
            Advance  Reason
    <input type="text" onChange={(e)=>setadvance_reason(e.target.value)} name="reason" className="form-control" />
 

    Bank Account
    <select name="bank_id"
            className="form-control"
            onChange={(e) => {setadvance_bank_id(e.target.value)}
               
             
            }
            required={true}
          >
            <option value=''>Select Bank</option>
           

            {staff_data?.bank_accounts?.map((i)=>{
           return <option value={i.id}>{i.bank} - {i.bank_account}</option>
            })}
                    
            </select>





 
 
    
  </div>
  <div className="col-md-1">
    </div>
  <div className="col-md-8"><br/>
  <h4> Deduction Plan to pay the advance total of : <b> ${amount_requested} </b> </h4><br/>
  <i> *  Deduction payment should start from : {staff_data?.start_month_salary_advance} </i>
  <br/><br/>
  <form id="add_deduction_plan" onSubmit={(e)=>e.preventDefault()}>

 <div className="row"> 
  <div className="col-md-3">
  Month  
    <select name="month"
            className="form-control"
            onChange={(e) => {setmonth(e.target.value)}
               
             
            }
            required={true}
          >
            <option value=''>Select Month </option>
            <option value={1}>January </option>
            <option value={2}>February </option>
            <option value={3}>March </option>
            <option value={4}>April </option>
            <option value={5}>May </option>
            <option value={6}>Jun </option>
            <option value={7}>July </option>

            <option value={8}>August </option>
            <option value={9}>September </option>
            <option value={10}>October </option>
            <option value={11}>November </option>
            <option value={12}>December </option>

          


            
          </select>
  </div>
  <div className="col-md-3">
  Year

  <select className="form-control" name="year" onChange={(e)=>setyear(e.target.value)}>
  <option value={getCurrentYear()}>{getCurrentYear()}</option>
  <option value={Number(getCurrentYear()-1)}>{Number(getCurrentYear()-1)}</option>

</select>
         
 

    </div> 
    <div className="col-md-3">
    
    Amount
          <input type="number" name="deduction_amount" className="form-control"   onChange={(e) => {setdecution_amount(e.target.value)}} />

    </div>
    <div className="col-md-2"><br/>
    <button className="btn btn-primary" onClick={()=>add_deduction_plan()}>
  Add
</button>
    </div>
 </div>


</form>
 
 
<br/>
<table className="info_table">
  <thead>
    <th>Year</th>
    <th>Month</th>
    <th>Amount</th>
    <th>...</th>


  </thead>
  {deduction_plans?.map((plan)=>{
    return <tr> <td>{plan.year}</td>    <td>{ get_month_name(plan.month)}</td>   <td>{plan.amount}</td> 
       <td> <FaTimesCircle style={{color:"red"}} onClick={()=>{
      if(window.confirm("Are you sure to delete this Deduction plan?")){
delete_plan(plan);
      }
    }}></FaTimesCircle> </td>
    </tr>
  })}
  <tr>
    <td></td>
    <td></td>
    <td><b>{get_deduction_plan_total()}</b></td>
    <td></td>
  </tr>
</table>
<br/>
{is_loading ? <><button className="btn btn-primary"  disabled={true} onClick={(e)=>{
  submit_advance_request();
}}>Processing...</button></> :
<button className="btn btn-primary"  disabled={deduction_plans.length==0} onClick={(e)=>{
  submit_advance_request();
}}>SUBMIT ADVANCE REQUEST</button>
}

<br/><br/>

  </div>
</div>
<h1>Advance History</h1>

<table className="info_table">
  <thead>
    <th>Request Date</th>
    <th>Reason</th>
    <th>Amount</th>
    


  </thead>
  {staff_data?.salary_advances?.map((a)=>{
    return <tr> <td>{a.date_requested}</td>      
    <td>{a?.salary_advance?.reason}</td> 
    <td>{ a.amount_requested}</td> 
    
    </tr>
  })}
  
</table>

 
                    
                  </div>
}

{active_tab==5 && 
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-7"><h1> Payslips </h1></div>
                      <br/>
                      <div className="col-md-5">
                   
                     
                       
                        </div>
                      </div>
                    
                     
               
                    <hr/>
                   

               

<div className="row">

  
   
  
 
 
<br/>
<table className="info_table">
  <thead>
  <th>Track Name</th>
  <th>Month</th>
    <th>Year</th>
    <th>Net Pay</th>
  
    <th>...</th>


  </thead>
  {staff_data?.payslips?.map((p)=>{
    return <tr> <td>{p?.track_name }</td> <td>{ get_month_name(p.year) }</td>    <td>{p.year }</td>   <td>{p.net_pay }</td>   
       <td> 
       <button
                  className="badge btn-primary"
                    onClick={() => {
                      history.push({
                        pathname: LOCAL_PATHS.PAYSLIP,
                        state: { data: { 
                          "track_id":p.track_id,
                          "staff_id":staff_data?.staff_id,
                        "month":p.month,
                        "year":p.year } },
                      });
                    }}
                  >
                   
                    
                    Print Payslip    &nbsp;  <FaArrowRight style={{ color: "white", cursor: "pointer" }} />
                  </button>
         </td>
    </tr>
  })}
 
</table>
<br/>
 
  </div>
 


               
 
                    
                  </div>
}


                  
                </div>
              </div>
            </div>
          </div>
        </div>
       
      </div>
      <Modal
        isOpen={show_bank_account_creation}
        onHide={() => setshow_bank_account_creation(false)}
        
        backdrop={true}
      
      >
        <ModalHeader  toggle={toggle}>
          <div className="row">
            Create Staff Bank Account           
          </div>
           
          
         </ModalHeader>
        <ModalBody>
      

        <form onSubmit={createBankAccount}>
<div className="row">
 <div className="col-md-6">
   Bank Name  
   <input type="text" name="bank_name" value={bank_name} onChange={(e)=>setbank_name(e.target.value)} className="form-control"/>  
   Bank Country  
  <select className="form-control" name="bank_country" onChange={(e)=>setbank_country(e.target.value)}>
    <option value="">Select Country</option>
    <option value="Somalia">Somalia</option>
    <option value="Kenya">Kenya</option>
    <option value="SouthSudan">South Sudan</option>
    <option value="Ethiopia">Ethiopia</option>



  </select>
    Bank Branch  
<input type="text" name="bank_branch" value={bank_branch} onChange={(e)=>setbank_branch(e.target.value)} className="form-control"/>
  
</div>
 
<div className="col-md-6">   
   Bank Account Name  
   <input type="text" name="bank_account_name" value={bank_account_name} onChange={(e)=>setbank_account_name(e.target.value)} className="form-control"/>
   Bank Account Number 
   <input type="text" name="bank_account_number" value={bank_account} onChange={(e)=>setbank_account(e.target.value)} className="form-control"/>


  </div>
  
<br/>

    </div>
    <br/>  
    <div className="row">
  {!is_loading?
    <input  type="submit" className="btn btn-primary" value="Save Bank Account" ></input> : <button className="btn btn-primary" disabled={true}><Spinner /> &nbsp; Processing..</button>  }

  </div>
    </form>
        </ModalBody>
      
      </Modal>
    </>
  )
}

export default EmployeeProfile